(() => {
  const previewId = document.body.dataset.previewTheme;
  if (previewId) {
    document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin === location.origin && !url.pathname.includes('/checkout') && !link.getAttribute('href').startsWith('#')) {
        url.searchParams.set('preview_theme_id', previewId);
        link.href = url.href;
      }
    });
    document.querySelectorAll('form[action]').forEach(form => {
      const url = new URL(form.action, location.href);
      if (url.origin === location.origin) {
        const field = document.createElement('input'); field.type = 'hidden'; field.name = 'preview_theme_id'; field.value = previewId; form.append(field);
      }
    });
  }
  const language = document.querySelector('[data-language-switch]');
  language?.addEventListener('change', () => {
    const url = new URL(location.href);
    const currentRoot = (document.body.dataset.localeRoot || '/').replace(/\/$/, '');
    const suffix = currentRoot && (url.pathname === currentRoot || url.pathname.startsWith(currentRoot + '/')) ? url.pathname.slice(currentRoot.length) : url.pathname;
    url.pathname = language.value.replace(/\/$/, '') + (suffix || '/');
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    location.assign(url.href);
  });
  const messages = JSON.parse(document.getElementById('vf-messages').textContent);
  const root = document.body.dataset.root.replace(/\/$/, '') + '/';
  const money = value => new Intl.NumberFormat(document.documentElement.lang, {style:'currency',currency:'EUR'}).format(value / 100);
  const toastBox = document.querySelector('.toast');
  const toast = text => { toastBox.querySelector('[data-toast-message]').textContent = text; toastBox.hidden = false; toastBox.classList.remove('is-added'); requestAnimationFrame(() => toastBox.classList.add('is-added')); };
  toastBox.querySelectorAll('[data-toast-close]').forEach(button => button.addEventListener('click', () => { toastBox.hidden = true; }));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') toastBox.hidden = true; });
  let cartBusy = false;
  let currentNativeCart = null;
  const syncNativeButtons = cart => {
    currentNativeCart = cart;
    const en = document.documentElement.lang.startsWith('en');
    document.querySelectorAll('.weight-form').forEach(form => {
      const id = Number(form.querySelector('[data-product-id]')?.value);
      const added = cart.items.some(item => item.product_id === id);
      const button = form.querySelector('button[type="submit"]');
      button.dataset.nativeEdit = String(added);
      button.textContent = added ? (en ? 'Edit' : 'Modifier') : messages.add;
    });
  };
  if (!document.getElementById('vf-draft-data') && document.querySelector('.weight-form')) {
    fetch(root + 'cart.js').then(response => response.json()).then(syncNativeButtons).catch(() => {});
  }
  document.querySelectorAll('.weight-form').forEach(form => {
    const select = form.querySelector('[data-weight-select]');
    const total = form.querySelector('[data-selection-price]');
    const shortcuts = form.querySelectorAll('[data-quick-weight]');
    const syncShortcuts = () => shortcuts.forEach(button => {
      const option = Array.from(select.options).find(option => Number(option.dataset.weight) === Number(button.dataset.quickWeight));
      button.disabled = !option || option.disabled;
      button.setAttribute('aria-pressed', String(option?.value === select.value));
    });
    shortcuts.forEach(button => button.addEventListener('click', () => {
      const option = Array.from(select.options).find(option => Number(option.dataset.weight) === Number(button.dataset.quickWeight));
      if (option && !option.disabled) { select.value = option.value; select.dispatchEvent(new Event('change')); }
    }));
    select.addEventListener('change', syncShortcuts); syncShortcuts();
    const syncTotal = () => { form.querySelector('.form-message').textContent = ''; total.textContent = money(Number(select.selectedOptions[0]?.dataset.price || 0) * Number(form.querySelector('[name="quantity"]')?.value || 1)); };
    select.addEventListener('change', syncTotal);
    form.querySelector('[data-native-quantity]')?.addEventListener('change', syncTotal);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (cartBusy) return;
      cartBusy = true;
      const button = form.querySelector('button[type="submit"]');
      if (button.dataset.nativeEdit === 'true') {
        cartBusy = false;
        const url = new URL(document.body.dataset.cartUrl, location.origin);
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        url.hash = 'cart-product-' + form.querySelector('[data-product-id]').value;
        location.assign(url.href); return;
      }
      const status = form.querySelector('.form-message');
      button.disabled = true; status.textContent = '';
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:Number(form.querySelector('[name="quantity"]')?.value || 1)}]})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || messages.error);
        const refreshed = await fetch(root + 'cart.js').then(r => r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = refreshed.item_count);
        syncNativeButtons(refreshed);
        toast(messages.added);
      } catch (error) { status.textContent = error.message || messages.error; }
      finally { cartBusy = false; button.disabled = !select.selectedOptions[0] || select.selectedOptions[0].disabled; }
    });
  });
  const grid = document.querySelector('[data-catalog]');
  if (grid) {
    const cards = Array.from(grid.querySelectorAll('.product-card'));
    const category = document.getElementById('vf-category');
    const search = document.getElementById('vf-search');
    const sidebar = document.querySelector('.catalog-sidebar');
    const groups = Array.from(grid.querySelectorAll('[data-category-group]'));
    const categoryButtons = Array.from(document.querySelectorAll('.category-children [data-category-filter]'));
    let activeCategory = null;
    let scrollFrame = 0;
    const updateScrollCategory = () => {
      scrollFrame = 0;
      const gridBounds = grid.getBoundingClientRect();
      const visibleGroups = groups.filter(group => !group.hidden && !group.closest('[data-family-group]').hidden);
      const marker = Math.min(160, window.innerHeight * 0.25);
      let current = null;
      if (window.innerWidth > 800 && gridBounds.top < window.innerHeight && gridBounds.bottom > 0) {
        current = visibleGroups[0];
        for (const group of visibleGroups) {
          if (group.getBoundingClientRect().top <= marker) current = group;
          else break;
        }
      }
      const name = current?.dataset.categoryGroup || null;
      if (name === activeCategory) return;
      activeCategory = name;
      categoryButtons.forEach(button => {
        if (button.dataset.categoryFilter === name) button.setAttribute('aria-current', 'location');
        else button.removeAttribute('aria-current');
      });
      const button = categoryButtons.find(button => button.dataset.categoryFilter === name);
      if (button && sidebar) {
        button.closest('details').open = true;
        const buttonBounds = button.getBoundingClientRect();
        const sidebarBounds = sidebar.getBoundingClientRect();
        if (buttonBounds.top < sidebarBounds.top + 12) sidebar.scrollTop += buttonBounds.top - sidebarBounds.top - 12;
        else if (buttonBounds.bottom > sidebarBounds.bottom - 12) sidebar.scrollTop += buttonBounds.bottom - sidebarBounds.bottom + 12;
      }
    };
    const scheduleScrollCategory = () => {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScrollCategory);
    };
    window.addEventListener('scroll', scheduleScrollCategory, {passive:true});
    window.addEventListener('resize', scheduleScrollCategory);
    window.addEventListener('pageshow', scheduleScrollCategory);
    let family = '';
    const params = new URLSearchParams(location.search);
    if (params.get('family') === 'fruits') family = 'vf-fruits';
    if (params.get('family') === 'legumes') family = 'vf-legumes';
    const filter = () => {
      const term = search.value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      let count = 0;
      cards.forEach(card => { const text = card.dataset.search.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); const group = card.closest('[data-category-group]'); card.hidden = Boolean((family && group?.dataset.family !== family) || (category.value && card.dataset.category !== category.value) || !text.includes(term)); if (!card.hidden) count++; });
      grid.querySelectorAll('[data-category-group]').forEach(group => { const visible = Array.from(group.querySelectorAll('.product-card')).filter(card => !card.hidden).length; group.hidden = visible === 0; group.querySelector('[data-group-count]').textContent = visible; });
      grid.querySelectorAll('[data-family-group]').forEach(group => group.hidden = !Array.from(group.querySelectorAll('[data-category-group]')).some(child => !child.hidden));
      document.querySelectorAll('[data-category-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.categoryFilter === category.value)));
      document.querySelectorAll('[data-family-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.familyFilter === family)));
      document.querySelector('[data-result-count]').textContent = count;
      document.querySelector('[data-no-results]').hidden = count > 0;
      scheduleScrollCategory();
    };
    document.querySelectorAll('[data-category-filter]').forEach(button => button.addEventListener('click', () => { family = ''; category.value = button.dataset.categoryFilter; filter(); }));
    document.querySelectorAll('[data-family-filter]').forEach(button => button.addEventListener('click', () => { family = button.dataset.familyFilter; category.value = ''; filter(); }));
    search.addEventListener('input', filter); category.addEventListener('change', () => { family = ''; filter(); }); filter();
  }
  const cartForm = document.getElementById('vf-cart');
  cartForm?.querySelectorAll('.remove').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    if (cartBusy) return;
    link.closest('.cart-item').querySelector('input[data-line-key]').value = '0';
    cartForm.requestSubmit(cartForm.querySelector('button[name="update"]'));
  }));
  if (cartForm) cartForm.addEventListener('submit', async event => {
    event.preventDefault();
    if (cartBusy) return;
    cartBusy = true;
    const checkout = event.submitter?.name === 'checkout';
    const status = cartForm.querySelector('.form-message');
    status.textContent = '';
    const buttons = cartForm.querySelectorAll('button[type="submit"]');
    buttons.forEach(button => button.disabled = true);
    try {
      const updates = {};
      const inputs = Array.from(cartForm.querySelectorAll('input[data-line-key]'));
      const existingKeys = new Map(inputs.map(input => [input.dataset.variantId, input.dataset.lineKey]));
      const targetQuantities = new Map();
      inputs.forEach(input => {
        updates[input.dataset.lineKey] = 0;
        const selected = input.closest('.cart-item').querySelector('[data-cart-variant]')?.value || input.dataset.variantId;
        targetQuantities.set(selected, (targetQuantities.get(selected) || 0) + Number(input.value));
      });
      targetQuantities.forEach((quantity, variantId) => { updates[existingKeys.get(variantId) || variantId] = quantity; });
      const response = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || messages.error);
      if (checkout) location.assign(root + 'checkout');
      else {
        const url = new URL(document.body.dataset.cartUrl, location.origin);
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        location.assign(url.href);
      }
    } catch(error) { status.textContent = error.message || messages.error; buttons.forEach(button => button.disabled = false); cartBusy = false; }
  });
})();
